import React from "react";
import BaseStepComponent from "./common/BaseStepComponent";

const Step2 = () => {
  return (
    <BaseStepComponent
      stepNumber={2}
      title="Agent Panel"
      videoSrc="https://contentmedius.s3.ap-south-1.amazonaws.com/part_2_-_agent_panel+(360p).mp4"
      directLink="https://contentmedius.s3.ap-south-1.amazonaws.com/part_2_-_agent_panel+(360p).mp4"
      nextStep={3}
    />
  );
};

export default Step2; 